import { UnstyledButton } from '@mantine/core';

import { IconFigmaLink } from '@/assets/icons';

interface LinkValueProps {
  value: string;
  onClick: () => void;
}

export const LinkValue = ({ value, onClick }: LinkValueProps) => (
  <UnstyledButton className="link-chip" onClick={onClick} title={value}>
    <IconFigmaLink size={16} />
    <span>{value}</span>
  </UnstyledButton>
);
